import Card from "../Card";

const Commodore = () => (
  <Card
    image="/images/fleet/commodore/Cedar_Hill_Angl1-2.jpg"
    title="Commodore"
    titleLink="/fleet/commodore"
    subtitle="Stealth Luxury on wheels"
    description='A 2006 Ford E350 Landship with a 140" wheelbase, extended body, and enhanced suspension; long, smooth-riding, and surprisingly spacious.<br><br>Tinted windows, thermal curtains, and a discrete design deliver true privacy for boondocking or urban stealth camping.'
    ctaText="Rent Commodore"
    ctaLink="/fleet/commodore"
    variant="image-left"
  />
);

export default Commodore;